import { render, staticRenderFns } from "./expanded-panel.vue?vue&type=template&id=b7c56ede"
import script from "./expanded-panel.vue?vue&type=script&lang=js"
export * from "./expanded-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports